import { Component, OnInit, Inject } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { CertificateFpDownloadRequest } from '@models/index.model';
import { CertificatesPrivateService, CustomValidators, DownloadFileServices, LoadingService } from '@services/index.service';
import { catchError, finalize, throwError } from 'rxjs';

@Component({
    selector: 'app-dialog-confirm-fp-backup',
    templateUrl: './dialog-confirm-fp-backup.component.html',
    styles: [],
    standalone: false
})
export class DialogConfirmFpBackupComponent implements OnInit {
  public isMobile: boolean;
  public downloadConfirmForm: UntypedFormGroup;
  public hide: boolean = true;
  public hide2: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmFpBackupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CertificateFpDownloadRequest,
    public dialog: MatDialog,
    private _fb: UntypedFormBuilder,
    private _loading: LoadingService,
    private _downloadServ: DownloadFileServices,
    private _certificatesServ: CertificatesPrivateService,
  ) {
    this.isMobile = environment.platform === 'mobile';
  }

  ngOnInit() {
    this.downloadConfirmForm = this._createDownloadConfirmForm();
  }

  private _createDownloadConfirmForm() {
    return this._fb.group({
      certificateRequestId: [this.data.certificateRequestId],
      passwordToEncrypt: [null, Validators.required],
      passwordToEncryptConfirm: [null, Validators.required],
      downloadingCode: [null, Validators.required]
    }, {
      validators: CustomValidators.fieldsMatch(['passwordToEncrypt', 'passwordToEncryptConfirm']),
    });
  }

  public onDownload() {
      const formValue = this.downloadConfirmForm.value;
      const certificateFpDownloadRequest: CertificateFpDownloadRequest = {
        certificateRequestId: formValue.certificateRequestId,
        passwordToEncrpyt: formValue.passwordToEncrypt,
        downloadingCode: formValue.downloadingCode
      };
      this._downloadFpCertificate(certificateFpDownloadRequest);
  }

  private _downloadFpCertificate(certificateFpDownloadRequest: CertificateFpDownloadRequest) {
    this._loading.showGlobalLoading();
    this._certificatesServ
      .downloadFpCertificate(certificateFpDownloadRequest)
      .pipe(
        finalize(() => this._loading.hideGlobalLoading()),
        catchError( err => {
          this._cleanDownloadConfirmForm();
          return throwError(err);
        })
      )
      .subscribe((res) => {
        const contentDispHeader: string = res.headers.get('Content-Disposition');
        const parts = /filename=([^;]+)/gi.exec(contentDispHeader);
        let fileName = parts[1] || 'untitled';
        fileName = decodeURIComponent(fileName);
        this._downloadServ.saveToFileSystem(new Blob([res.body]), fileName);
        this.dialogRef.close(true);
      });
  }

  public isFieldRequired(fieldName: string): boolean {
    const fieldControl: AbstractControl = this.downloadConfirmForm.get(fieldName);
    return fieldControl.touched && fieldControl.errors && fieldControl.errors.required;
  }

  private _cleanDownloadConfirmForm(): void {
      Object.keys(this.downloadConfirmForm.controls)
      .filter((keyName: string) => keyName !== 'certificateRequestId')
      .forEach((keyName: string) => {
        const control = this.downloadConfirmForm.get(keyName);
        control.reset();
        control.updateValueAndValidity();
      });

  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
